










import { Component, Vue } from 'vue-property-decorator';
import { authModule } from '@/store';
import Avatar from './common/Avatar.vue';

@Component({
  name: 'user-menu',
  components: { Avatar },
})
export default class UserMenu extends Vue {
  get user() {
    return authModule.whoIam;
  }

  goUsers() {
    this.$router.push({ name: 'users' });
  }

  logout() {
    authModule
      .logout()
      .then(() => {
        this.$router.push({ name: 'login' });
      })
      .catch((e) => {
        this.$message.error(e);
      });
  }
}
